// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"input-with-submit.module-inputWrapper--63f9e"};